/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { CMSYmme } from '@/features/contentstack/components/CMSYmme/CMSYmme';

export function CMSCategoryYMME() {
  return <CMSYmme removeMargins nonShopPage={true} />;
}
